import axios, { AxiosPromise } from "axios";
import IElearning from "../types/IElearning";

export const getElearnings = (): AxiosPromise<[IElearning[], number]> =>
  axios.get(`/api/elearning`);
export const getElearning = (id: number | string): AxiosPromise<IElearning> =>
  axios.get(`/api/elearning/${id}`);
